<template>
    <v-list two-line style="max-height: 275px; min-height: 275px; background-color: #fff;" class="overflow-y-auto">
        <v-list-item-group v-model="selectedResources" multiple active-class="pink--text">
            <div class="text-center" style="margin-bottom: 6px; font-size: 12px; font-weight: 500;">{{ this.selectedResources.length }} selected Ressources</div>
            <div class="text-center" style="margin-bottom: 6px; color: red; font-size: 14px; font-weight: 500;">
                <template v-for="(item1) in selectedResources3LetterCodes">
                    {{ item1 }}&nbsp;
                </template>
            </div>

            <template v-for="(item, index) in get_AllEmployees">
                <v-list-item :key="item.id" :value="item.id" style="background-color: #fff;">
                    <template v-slot:default="{}">
                        <v-list-item-icon>
                            <v-icon>mdi-account-circle</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>
                                <span style="font-size: 14px; font-weight: 500;">{{ item.genLastname.trim() }}, {{ item.genFirstName.trim() }} ({{ item.contractFunction }}) - </span>
                                <span style="font-size: 12px; font-weight: 400;">&nbsp;&nbsp;&nbsp;Last Release: {{ item.lastDutyPlanRelease | formattedDate }}</span>
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                </v-list-item>

                <v-divider v-if="index + 1 < get_AllEmployees.length" v-bind:key="'div_' + index"></v-divider>
            </template>
        </v-list-item-group>
    </v-list>
</template>

<script>
    import { mapGetters } from 'vuex';

    import moment from 'moment';


    export default {
        name : 'AllEmployeesList',

        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note: Select all.
        *
        */
        mounted: function() {

            let me = this;


            me.$toc('>>> views/shared/components/AllEmployeesList.vue >>> mounted');
            this.on_selectAll();

        }, // eo mounted()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                selectedResources: [], // selected Resources
                selectedResources3LetterCodes: [], // selected Resources 3 Letter Codes
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            selectedResources(value) {

                this.$emit('input', value);

            }, // eo selectedResources()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_AllEmployees',
                'get_selectedMultiResources',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Filters */
        filters: {

            /*******************************************************************
            * formattedDate()
            *
            * Desc:
            *
            * @param {string} date (Date to reformat)
            * @return {string}
            */
            formattedDate: function(date) {

                return moment(date, moment.ISO_8601).format('DD.MM.YYYY'); // de:
                // return moment(date, moment.ISO_8601).format('MMM DD, YYYY'); // en: JAN 30, 2019

            }, // eo function formattedDate()

        }, // eo filters{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * on_selectAll()
            *
            * Desc: Select all Resources.
            * Note: Ressources can be 'preSelected' in Table.
            *
            */
            on_selectAll: function(){

                let me = this,
                    allResources = [],
                    allResources3LetterCodes = [];


                me.$toc('>>> views/shared/components/AllEmployeesList.vue >>> on_selectAll');
                if (this.get_selectedMultiResources.length === 0) {
                    this.get_AllEmployees.forEach((item) => {
                        allResources.push(item.id);
                    });
                    this.selectedResources = [...allResources];
                }


                if (this.get_selectedMultiResources.length > 0) {
                    this.get_selectedMultiResources.forEach((item) => {
                        allResources.push(item.id);
                        allResources3LetterCodes.push(item.contract3Code);
                    });
                    this.selectedResources = [...allResources];
                    this.selectedResources3LetterCodes = [...allResources3LetterCodes];
                }

            }, // eo function on_selectAll()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .v-card .v-divider {
        border-color: #d2d2d2;
    }

    .v-list-item {
        padding: 0 26px;
    }

    .v-list--two-line .v-list-item, .v-list-item--two-line {
        min-height: 45px;
        max-height: 45px;
    }
</style>